import React, { useContext, useEffect, useState } from "react";
import DashboardLayout from "../../layout/dashboard";
import {
    Avatar,
    AvatarGroup,
    Box,
    Flex,
    Image,
    Spacer,
    Text,
} from "@chakra-ui/react";
import { circlePattern, ring } from "../../images";
import { communityRoute } from "../../utils/allRoutes";
import { useNavigate } from "react-router-dom";
import { httpGetWithTokenRest } from "../../utils/http_utils";

export default function CareCircleCard({ community }) {
    const navigate = useNavigate();
    const [unreadMessages, setUnreadMessages] = useState(0)
    const _useFireBase = async () => {
        let allMessages= community.messages;
        // get deleted for all
        let deleted4MeAll = []
        let resp = await httpGetWithTokenRest(`deleted-message/${community.id}`);
        if (resp.error !== null && resp.error !== undefined) {
        } else {
          let d = resp.data;
          deleted4MeAll = d.map((msg)=> {return msg.del_timestamp})
        }
        // get deleted 4 me
        let deleted4Me = []
        resp = await httpGetWithTokenRest(`deleted-message/me/${community.id}`);
        if (resp.error !== null && resp.error !== undefined) {
        } else {
          let d = resp.data;
          deleted4Me = d.map((msg)=> {return msg.del_timestamp})
        }

        // get read messages | array of timestamps
        let allReadMessages = [];
        resp = await httpGetWithTokenRest(`care_circle/read-messages/${community.id}`);
        if (resp.error !== null && resp.error !== undefined) {
        } else {
          let d = resp.data;
          allReadMessages = d;
        }
        allMessages = allMessages.filter((f)=>deleted4Me.includes(f.toString()) === false)
        allMessages = allMessages.filter((f)=>deleted4MeAll.includes(f.toString()) === false)
        
        let unRead = allMessages.filter((m) => allReadMessages.includes(m.toString()) == false);
        console.log(allMessages, allReadMessages, unRead)
        setUnreadMessages(unRead.length)
      }
      useEffect(()=> {
        _useFireBase()
      }, [])
    const getRandomColors = () => {
        const colorList = [
            {
                textColor: "secondary",
                bgColor: "#FF6E57",
            },
            {
                textColor: "primary",
                bgColor: "primary",
            },
            {
                textColor: "secondary",
                bgColor: "#36BBE2",
            },
        ];
        return colorList[Math.floor(Math.random() * colorList.length)];
    };
    return (
        <Box key={community.id} position={"relative"}>
            {
                unreadMessages > 0
                &&
                <Box
                position={"absolute"}
                borderRadius={"100%"}
                bg={"green.800"}
                boxSize={"20px"}
                color={"white"}
                top={2}
                right={2}
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                fontSize={"10px"}
                >
                {unreadMessages}
                </Box>
                }

            <Box
                bg={getRandomColors().bgColor}
                bgImage={circlePattern}
                bgRepeat={"no-repeat"}
                bgPosition={"right"}
                bgSize={"contain"}
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
                minH={{base : "124px", md : "180px", lg : "180px"}}
                py={4}
                px={3}
                color={"#ffffff"}
                borderRadius={16}
                cursor={"pointer"}
                onClick={
                    () => {
                        navigate(`${communityRoute}/${community?.id}`)
                    }
                }
            >

                <Box style={{
                    position : "relative"
                }}>
                    <Image src={ring} 
                    boxSize={{base : "85px", md : "100px", lg : "100px"}} />
                    <Box
                    position={"absolute"}
                    borderRadius={"100%"}
                    bg="transparent"
                    boxSize={{base : "85px", md : "100px", lg : "100px"}}
                    top={0}
                    left={0}
                    justifyContent={"center"}
                    alignItems={"center"}
                    display={"flex"}
                    >
                <Box
                style={{
                    padding : 2,
                    borderRadius : "100%",
                    background : "white"
                }}
                >
                {community?.jorner?.avatar ? (
                  <Image
                    boxSize={{base : "71px", md : "84px", lg : "84px"}}
                    borderRadius={"100%"}
                    src={community?.jorner?.avatar}
                  />
                ) : (
                  <Box
                    fontWeight="600"
                    color="white"
                    boxSize={{base : "71px", md : "84px", lg : "84px"}}
                    borderRadius={"100%"}
                    display="flex"
                    background={"secondary"}
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Text fontSize={"24px"}>
                      {community?.jorner?.first_name?.substring(0, 1)}
                      {community?.jorner?.last_name?.substring(0, 1)}
                    </Text>
                  </Box>
                )}
                </Box>
              </Box>
                </Box>
                <Box 
                    boxSize={"12px"}
                ></Box>
                <Box flex={1}>
                    <Text fontSize={18.9} fontWeight={600} mb={3}>
                        {community?.name.substring(0, 12)}{community?.name.length > 12 ? ".." : ""}
                    </Text>
                    <Text fontSize={12} fontWeight={400} mb={3}>
                        {community?.descriptions.substring(0, 25)}{community?.descriptions.length > 25 ? ".." : ""}

                    </Text>
                    <Flex
                        alignItems={"center"}
                        display={{
                            base: "block",
                            md: "block",
                            lg: "block",
                            xl: "flex",
                        }}
                    >
                        <AvatarGroup
                            size="sm"
                            max={3}
                            mr={community.members.length > 3 ? 0 : 2}
                        >
                            {community.members.map((e, i) => (
                                <Avatar
                                    name={e?.first_name}
                                    src={e?.avatar}
                                />
                            ))}
                        </AvatarGroup>
                        <span>members</span>
                        <Spacer />
                    </Flex>
                </Box>

            </Box>
        </Box>
    )
}